document.addEventListener('DOMContentLoaded', function () {
  const thumbsEl = document.querySelector('.product_media_thumbs_slider');
  const mainEl = document.querySelector('.product_media_main_slider');

  if (!thumbsEl || !mainEl) return;

  const syncThumbHeight = () => {
    thumbsEl.style.height = `${mainEl.offsetHeight}px`;
  };

  const productMediaThumbsSlider = new Swiper(thumbsEl, {
    direction: 'vertical',
    spaceBetween: 10,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    mousewheel: true,
    breakpoints: {
      0: {
        direction: 'horizontal'
      },
      990: {
        direction: 'vertical'
      }
    }
  });

  const productMediaMainSlider = new Swiper(mainEl, {
    spaceBetween: 10,
    slidesPerView: 1,
    navigation: {
      nextEl: mainEl.querySelector('.swiper-button-next'),
      prevEl: mainEl.querySelector('.swiper-button-prev')
    },
    thumbs: {
      swiper: productMediaThumbsSlider
    },
    on: {
      init: function () {
        syncThumbHeight();
      },
      slideChange: function () {
        if (productMediaThumbsSlider) {
          productMediaThumbsSlider.slideTo(this.activeIndex);
        }
      }
    }
  });

  window.addEventListener('load', function () {
    syncThumbHeight();
    productMediaThumbsSlider.update();
    productMediaMainSlider.update();
  });

  window.addEventListener('resize', function () {
    syncThumbHeight();
    productMediaThumbsSlider.update();
    productMediaMainSlider.update();
  });
});